import { CriteriaAggregateType, CriteriaTokenType, } from '../../../types';
// inverse of ../to/aggregateCriteriaToFilterDto
export default function dtoToAggregateCriteria(filter, stripes, intl) {
    if (!filter || typeof filter.property !== 'string' || typeof filter.condition !== 'string' || typeof filter.amount !== 'number') {
        return undefined;
    }
    switch (filter === null || filter === void 0 ? void 0 : filter.property) {
        case CriteriaTokenType.NUM_ROWS:
            return {
                type: CriteriaAggregateType.NUM_ROWS,
                operator: filter.condition,
                amount: intl.formatNumber(filter.amount, { style: 'currency', currency: stripes.currency }),
            };
        case CriteriaTokenType.TOTAL_AMOUNT:
            return {
                type: CriteriaAggregateType.TOTAL_AMOUNT,
                operator: filter.condition,
                amountCurrency: intl.formatNumber(filter.amount / 100, { style: 'currency', currency: stripes.currency }),
            };
        default:
            return undefined;
    }
}
